<template>
  <div>
    space<b>studio</b>™ provides built-in cost functions that
    require the following inputs:
    <ul>
      <li>
        propulsion system cost to account for the price of a propulsion system
        solution;
      </li>
      <li>
        duration cost to account for the loss of revenue when spacecrafts are
        not fulfilling their mission (when they are manoeuvring for instance);
      </li>
      <li>mass cost to account for the cost of sending mass into space.</li>
    </ul>
    <br />
    The cost results that can be obtained are described in the table below:
    <br />
    <br />
    <v-img
      contain
      :src="require('../../assets/images/tooltip-costs.png')"
      aspect-ratio="2.95"
    />
    <br />
    <i>Nota Bene: </i> cost results that depend on undefined inputs will be
    shown as "undefined".
  </div>
</template>

<script>
export default {
  name: 'tooltipCosts'
}
</script>
